import { getSessionStorage } from '../../../_common/client/session-storage';
import { sessionStorageKeyIsExpandedPrefix } from './constants';

export const readExpansionStatusFromStorage = (productId: string): boolean => {
    const sessionStorage = getSessionStorage();
    return sessionStorage.getItem(`${sessionStorageKeyIsExpandedPrefix}-${productId}`) === 'true';
};
